module.exports = __webpack_public_path__ + "images/emoji/shipit.0bf1d3de309a89d9ed70.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/shipit.png
// module id = EMOA
// module chunks = 24